export class ColumnInfo {
    public dataPropertyName: string;
    public caption: string;
}

export class ColumnInfoBase {
    public title: string;
    public columnsInfo: ColumnInfo[];
}
